<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="评论内容">
            <el-input
                v-model="formInline.content"
                placeholder="评论内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="评论人">
            <el-input @focus="userFocus" v-model="userName" placeholder="评论人"></el-input>
          </el-form-item>
          <el-form-item label="评论状态">
            <el-select v-model="formInline.type" placeholder="评论状态">
              <el-option label="评论" value="1"></el-option>
              <el-option label="回复" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属板块">
            <el-select v-model="region" placeholder="所属板块" @change="handleRegionChange">
              <el-option label="中医智库" value="1"></el-option>
              <el-option label="家庭中医馆" value="2"></el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-select v-model="formInline.link_type" placeholder="所属板块">
              <el-option v-for="(item,index) in options" :key="index" :label='item.label'
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态">
            <el-select v-model="formInline.status" placeholder="状态" @change="statusChange">
              <el-option label="全部" value="0"></el-option>
              <el-option label="已通过" value="1"></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="垃圾" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="float: right;margin-bottom: 10px">
        <el-select v-model="status_type" placeholder="批量操作">
          <el-option v-for="(item,index) in status_Data" :key="index" :label='item.label'
                     :value="item.value"></el-option>
        </el-select>
        <span style="width: 20px;display: inline-block"></span>
        <el-button type="primary" @click="allGames">批量管理</el-button>
      </div>
      <el-table
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          v-loading="loading"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
      >
        <el-table-column
            type="selection"
            width="45">
        </el-table-column>
        <el-table-column
            prop="id"
            label="ID"
            align="center"
        ></el-table-column>
        <el-table-column
            prop=""
            label="评论人"
            align="center"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.user_name }}</p>
            <p style="cursor: pointer;color: #2d8cf0" v-if="scope.row.prohibition_status==0"
               @click="estoppel(scope.row)">禁言</p>
            <p style="cursor: pointer;color: #f02d2d" v-if="scope.row.prohibition_status==1">
              {{ scope.row ? scope.row.prohibition_end_time == -1 ? '永久禁言' : formatDate(scope.row.prohibition_end_time) : '' }}</p>
            <p style="cursor: pointer;color: #2d8cf0" v-if="scope.row.prohibition_status==1"
               @click="cancelEstoppel(scope.row)">解禁</p>
          </template>
        </el-table-column>
        <el-table-column
            prop="content"
            label="评论内容"
            align="center"
            width="200"
        >
          <template slot-scope="scope">
            <p>
              {{scope.row.to_user_name?'回复给:'+scope.row.to_user_name:''}}
            </p>
            <p>
              {{scope.row.content}}
            </p>
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="评论来源"
            align="center"
            width="300"
        >
          <template slot-scope="scope">
            <p style="cursor: pointer;color: #2d8cf0" v-if="scope.row.link_type!= 11" @click="goInfo(scope.row)" v-html="scope.row.title"></p>
            <p v-if="scope.row.link_type==11">{{ scope.row.title }}</p>
          </template>
        </el-table-column>
        <el-table-column

            label="所属板块"
            align="center"
        >
          <template slot-scope="scope">
            <p>{{ linkTypeFomart(scope.row.link_type) }}</p>
          </template>
        </el-table-column>
        <el-table-column
            prop="reply_count"
            label="回复数"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="like_count"
            label="点赞数"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="like_count"
            label="评论时间"
            align="center"
        ></el-table-column>
        <el-table-column
            label="状态"
            align="center"
        >
          <template slot-scope="scope">
            {{ formatStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <span style="cursor: pointer;color: #2d8cf0" @click="operate(scope.row,1)"
                  v-if="scope.row.status ==2">批准</span>&nbsp;&nbsp;&nbsp;
            <span style="cursor: pointer;color: #2d8cf0" @click="operate(scope.row,2)"
                  v-if="scope.row.status ==1">驳回</span>&nbsp;&nbsp;&nbsp;
            <span style="cursor: pointer;color: #2d8cf0" @click="operate(scope.row,3)"
                  v-if="scope.row.status !=3">垃圾</span>&nbsp;&nbsp;&nbsp;
            <span style="cursor: pointer;color: #2d8cf0" @click="operate(scope.row,4)" v-if="scope.row.status ==3">不是垃圾</span>&nbsp;&nbsp;&nbsp;
            <span style="cursor: pointer;color: #2d8cf0" @click="operate(scope.row,5)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="page_size"
            :page-count="totalPages"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div class="userInfo" v-show="userShow">
        <div class="userList">
          <div class="header">
            <h3>搜索用户</h3>
            <el-input v-model="userPhone" placeholder="请输入手机号"></el-input>
            <el-button type="primary" @click="searchUser">搜索</el-button>
          </div>
          <div class="tab">
            <el-table
                v-loading="loadings"
                :data="userData"
                border
                class="table"
                ref="usermultipleTable"
                header-cell-class-name="table-header"
                tooltip-effect="dark"
                @selection-change="handleUserSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="45">
              </el-table-column>
              <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="nickname"
                  label="昵称"
                  align="center"
              ></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="userPage"
                :page-size="userPagepage_size"
                :page-count="userPagetotalPages"
                @current-change="handleUserPageChange"
            ></el-pagination>
          </div>
          <div class="bot">
            <el-button type="" @click="cancelUser">取消</el-button>
            <el-button type="primary" @click="okUser">确认</el-button>
          </div>
        </div>
      </div>
      <el-dialog
          title="禁言"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
        <div class='bizui'>
          <div class="bz1">
            <span class="left">
              时长：
            </span>
            <span class="right">
              <el-select v-model="days" placeholder="禁言时长">
                <el-option label='一天' value="1"></el-option>
                <el-option label='一周' value="7"></el-option>
                <el-option label='30天' value="30"></el-option>
                <el-option label='永久' value="-1"></el-option>
              </el-select>
            </span>
          </div>
          <div class="bz2">
            <span class="left">
              类型：
            </span>
            <span class="right">
              <el-select v-model="type" placeholder="禁言类型">
                <el-option v-for="(item,index) in jyType" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </span>
          </div>

        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="okJy">确 定</el-button>
  </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import http from "../../../api/hemeraApiConfig";
import http2 from '../../../api/gaeaApiConfig'
import http3 from '../../../api/zkApiConfig'
import httpPCURL from '../../../api/zkwayApiConfig'
import httpH5URL from '../../../api/zkwayApiConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      jyData:{},
      jjData:{},
      jyType:[],
      days: '',
      type: '',
      userShow: false,
      formInline: {
        link_type: '0',
        title: '',
        user_id: '',
        content: '',
        status: '0',
        type: '1',
      },
      tableData: [],
      userData: [],
      totalPages: 0,
      currentPage: 1,
      page_size: 10,
      userPage: 1,
      userPagetotalPages: 1,
      userPagepage_size: 10,
      pageTotal: 10,
      loading: false,
      loadings: false,
      region: '1',
      options: [
        {'label': '全部', 'value': '0'},
        {'label': '域外库', 'value': '1'},
        {'label': '基础古籍库', 'value': '2'},
        {'label': '孤本库', 'value': '3'},
        {'label': '圈子-回答', 'value': '4'},
        {'label': '圈子-笔记', 'value': '5'},
        {'label': '知识库-方剂', 'value': '6'},
        {'label': '知识库-医案', 'value': '7'},
        {'label': '知识库-本草', 'value': '8'},
        {'label': '知识库-经穴', 'value': '9'},
        {'label': '知识库-名医', 'value': '10'},
      ],
      status_Data: [
        {"label": '批准', value: '1'},
        {"label": '驳回', value: '2'},
        {"label": '垃圾', value: '3'},
        {"label": '删除', value: '5'},
      ],
      status_type: '1',
      allData: [],
      userPhone: '',
      userName: '',
      userDatas: [],
      userIds: [],
      userNames: [],
      currentId:"",
    };
  },
  created() {
  },
  mounted() {
    this.onSubmit()
  },
  methods: {

    searchUser() {
      this.loadings = true
      let data = {
        page: this.userPage,
        page_size: this.userPagepage_size,
        phone: this.userPhone,
      }
      http2.get('admin/users', {params: data}).then(res => {
        if (res.data.status_code == 200) {
          this.loadings = false
          this.userData = res.data.data.users
          this.userPagetotalPages = res.data.data.total_pages
        }
      })
    },
    //用户列表操作
    handleUserSelectionChange(val) {
      this.userDatas = val
    },

    cancelUser() {
      this.userShow = false
    },
    okUser() {
      this.userIds=[]
      this.userNames=[]
      for (let i = 0; i < this.userDatas.length; i++) {
        this.userIds.push(this.userDatas[i].id)
        this.userNames.push(this.userDatas[i].nickname)
      }
      console.log(this.userNames);
      this.userName = this.userNames.toString()
      this.formInline.user_id = this.userIds.toString()
      this.userShow = false
    },
    //查询用户
    userFocus() {
      this.userShow = true
      this.searchUser()
      this.toggleSelection(this.userDatas)
    },
    //默认选中
    toggleSelection(rows) {
      setTimeout(()=>{
        this.loadings = false
        if (rows) {
          for (let i = 0; i < this.userData.length; i++) {
            for (let j = 0; j < this.userIds.length; j++) {
              if(this.userIds[j]==this.userData[i].id){
                this.$nextTick(()=>{this.$refs.usermultipleTable.toggleRowSelection(this.userData[i], true);})
              }
            }
          }
        }
      },1000)
    },
    //查询
    onSubmit() {
      if (this.region == 2) {
        this.formInline['page'] = this.currentPage
        this.formInline['page_size'] = this.page_size
        http.get('/admin/comments', {params: this.formInline}).then(res => {
          if (res.data.status_code == 200) {
            this.tableData = res.data.data.items
            this.totalPages = res.data.data.total_pages
          }
        })
      }else {
        this.formInline['page'] = this.currentPage
        this.formInline['page_size'] = this.page_size
        http3.get('/admin/comment/list', {params: this.formInline}).then(res => {
          if (res.data.status_code == 200) {
            this.tableData = res.data.data.items
            this.totalPages = res.data.data.total_pages
          }
        })
      }
    },
    // 所属板块
    handleRegionChange(e) {
      this.region = e
      if (e == 1) {
        this.options = [
          {'label': '全部', 'value': '0'},
          {'label': '域外库', 'value': '1'},
          {'label': '基础古籍库', 'value': '2'},
          {'label': '孤本库', 'value': '3'},
          {'label': '圈子-回答', 'value': '4'},
          {'label': '圈子-笔记', 'value': '5'},
          {'label': '知识库-方剂', 'value': '6'},
          {'label': '知识库-医案', 'value': '7'},
          {'label': '知识库-本草', 'value': '8'},
          {'label': '知识库-经穴', 'value': '9'},
          {'label': '知识库-名医', 'value': '10'},
        ]
        this.formInline.link_type = this.options[0].value
      } else {
        this.options = [
          {'label': '资讯', 'value': '11'},
        ]
        this.formInline.link_type = this.options[0].value
      }
    },
    //状态更改
    statusChange(e) {
      if (e == 0) {
        this.status_Data = [
          {"label": '批准', value: '1'},
          {"label": '驳回', value: '2'},
          {"label": '垃圾', value: '3'},
          {"label": '删除', value: '5'},
        ]
        this.status_type = this.status_Data[0].value
      } else if (e == 1) {
        this.status_Data = [
          {"label": '驳回', value: '2'},
          {"label": '垃圾', value: '3'},
          {"label": '删除', value: '5'},
        ]
        this.status_type = this.status_Data[0].value
      } else if (e == 2) {
        this.status_Data = [
          {"label": '批准', value: '1'},
          {"label": '垃圾', value: '3'},
          {"label": '删除', value: '5'},
        ]
        this.status_type = this.status_Data[0].value
      } else if (e == 3) {
        this.status_Data = [
          {"label": '不是垃圾', value: '4'},
          {"label": '删除', value: '5'},
        ]
        this.status_type = this.status_Data[0].value
      }
    },
    // 翻页
    handlePageChange(val) {
      this.currentPage = val;
      this.onSubmit();
    },
    handleUserPageChange(val) {
      this.userPage = val;
      this.searchUser();
      this.toggleSelection(this.userDatas)
    },
    // 多选框
    handleSelectionChange(val) {
      this.allData = val
    },
    //禁言
    estoppel(row) {
      http2.get('admin/user/estoppel/types').then(res=>{
        this.jyType = res.data.data
      })
      this.jyData = row
      this.dialogVisible = true
    },

    //关闭禁言
    handleClose() {
      this.dialogVisible=false
    },
    okJy(){
      let data ={
        type:this.type,
        days:this.days,
      }
      http2.put('admin/user/'+this.jyData.user_id+'/estoppel',data).then(res=>{
        if(res.data.status_code == 200){
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.onSubmit()
          this.dialogVisible=false
          this.type=''
          this.days=''
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          });
        }
      })
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    //解禁
    cancelEstoppel(row) {
      this.jjData = row
      this.$confirm('此操作将接触此用户禁言,是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        http2.put('admin/user/'+row.user_id+'/un_estoppel').then(res=>{
          if(res.data.status_code == 200){
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.onSubmit()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    //去详情
    goInfo(row){
      console.log(row)
      //域外库1
      if(row.link_type == 1){
        window.open(httpPCURL+'/famousDetail?id='+row.link_id+"&classType=2-2&key=2-2",'_blank',)
      }
      //古籍库2
      if(row.link_type == 2){
        window.open(httpPCURL+'/famousDetail?id='+row.link_id+"&classType=2-1&key=2-1",'_blank',)
      }
      //孤本库3
      if(row.link_type == 3){
        window.open(httpPCURL+'/famousDetail?id='+row.link_id+"&classType=2-3&key=2-3",'_blank',)
      }
      // 圈子-回答4
      if(row.link_type == 4){
        window.open(httpPCURL+'/questionDetail?questionId='+row.link_id+"&key=5",'_blank',)
      }
      // 圈子-笔记5
      if(row.link_type == 5){
        let data = {
          question_id:row.link_id,
          type:'4',
          answer_id:'',
        }
        window.open(httpH5URL+'/pages/medicineCircle/tagInfo?data='+JSON.stringify(data),'_blank',)
      }
      // 知识库-方剂6
      if(row.link_type == 6){
        window.open(httpPCURL+'/fangcategoriesInfo?fangid='+row.link_id+"&key=3-2",'_blank',)
      }
      // 知识库-医案7
      if(row.link_type == 7){
        window.open(httpPCURL+'/knowledgeInfo?case_id='+row.link_id+"&key=3-1",'_blank',)
      }
      // 知识库-本草8
      if(row.link_type == 8){
        window.open(httpPCURL+'/categoriesInfo?id='+row.link_id+"&key=3-4",'_blank',)
      }
      // 知识库-经穴9
      if(row.link_type == 9){
        window.open(httpPCURL+'/jxcategoriesInfo?id='+row.link_id+"&key=3-5",'_blank',)
      }
      // 知识库-名医10
      if(row.link_type == 10){
        window.open(httpPCURL+'/perscrInfo?id='+row.link_id+"&key=3-3",'_blank',)
      }
    },

    //状态格式化
    formatStatus(row) {
      if (row == 1) {
        return '已通过'
      }
      if (row == 2) {
        return '待审核'
      }
      if (row == 3) {
        return '垃圾'
      }
    },
    //板块格式化
    linkTypeFomart(type) {
      if (type == 1) {
        return '域外库'
      }
      if (type == 2) {
        return '基础古籍库'
      }
      if (type == 3) {
        return '孤本库'
      }
      if (type == 4) {
        return '圈子-回答'
      }
      if (type == 5) {
        return '圈子-笔记'
      }
      if (type == 6) {
        return '知识库-方剂'
      }
      if (type == 7) {
        return '知识库-医案'
      }
      if (type == 8) {
        return '知识库-本草'
      }
      if (type == 9) {
        return '知识库-经穴'
      }
      if (type == 10) {
        return '知识库-名医'
      }
      if (type == 11) {
        return '文章-资讯（家庭中医馆）'
      }
    },
    // 批量操作
    allGames() {
      let idArr = []
      let reply_count = 0
      for (let i = 0; i < this.allData.length; i++) {
        idArr.push(this.allData[i].id)
        reply_count+= this.allData[i].reply_count
      }
      let data = {
        type: this.formInline.type,
        status: this.status_type
      }
      let ids = idArr.toString()
      let text = this.status_type == '1' ? '此操作将批准该内容, 是否继续?'
          : this.status_type == '2' ? '此操作将驳回该内容, 是否继续?'
              : this.status_type == '3' ? '此操作将该内容设为垃圾, 是否继续?'
                  : this.status_type == '4' ? '此操作将该内容设为不是垃圾, 是否继续?'
                      : this.status_type == '5' ? '该评论下包含'+reply_count+'条回复,将一并删除, 是否继续?' : ''
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //其他批量操作
        if (this.status_type != '5') {
          if(this.region == 2){
            http.put('admin/comments/' + ids, data).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }else {
            http3.put('admin/comment/' + ids, data).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }

        } else {
          //删除操作
          if(this.region == 2){
            http.delete('admin/comments/' + ids, {params: {type:  this.formInline.type}}).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }else {
            http3.delete('admin/comment/' + ids, {params: {type:  this.formInline.type}}).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }

        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //单独操作
    operate(row, type) {
      let ids = row.id
      let reply_count = row.reply_count
      let data = {
        type:  this.formInline.type,
        status: type,
      }
      let text = type == '1' ? '此操作将批准该内容, 是否继续?'
          : type == '2' ? '此操作将驳回该内容, 是否继续?'
              : type == '3' ? '此操作将该内容设为垃圾, 是否继续?'
                  : type == '4' ? '此操作将该内容设为不是垃圾, 是否继续?'
                      : type == '5' ? '该评论下包含'+reply_count+'条回复,将一并删除, 是否继续?' : ''
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //其他批量操作
        if (type != '5') {
          if(this.region == 2){
            http.put('admin/comments/' + ids, data).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }else {
            http3.put('admin/comment/' + ids, data).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }

        } else {
          //删除操作
          if(this.region == 2){
            http.delete('admin/comments/' + ids, {params: {type:  this.formInline.type}}).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }else {
            http3.delete('admin/comment/' + ids, {params: {type:  this.formInline.type}}).then(res => {
              if (res.data.status_code == 200) {
                this.onSubmit()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg
                });
              }
            })
          }

        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
  },
}
</script>

<style scoped>
.userInfo {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.userList {
  border: 1px solid #ccc;
  width: 1000px;
  height: 660px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 80px;
  background: #fff;
  margin-bottom: 10px;
}

.header h3 {
  width: 100%;
  height: 35px;
}

.header .el-input {
  width: 200px;
  margin-right: 20px;
}

.tab {
  flex: 1;
}

.bot {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination {
  margin: 20px 0;
  text-align: center;
}
.bizui{
  width: 100%;
  height: 100%;
}
.bz1{
  width: 100%;
  height:50px;
  padding-left: 40px;
  box-sizing: border-box;
}
.bz2{
  width: 100%;
  height: 50px;
  padding-left: 40px;
  box-sizing: border-box;
}
</style>